import { render, staticRenderFns } from "./ScalesComponent.vue?vue&type=template&id=19faeaea&scoped=true"
import script from "./ScalesComponent.vue?vue&type=script&lang=js"
export * from "./ScalesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19faeaea",
  null
  
)

export default component.exports